
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcSequenceCard as ObcSequenceCardElement} from '@oicl/openbridge-webcomponents/dist/components/sequence-card/sequence-card.js';
 
 
 

 
 export const ObcSequenceCard = createComponent({
   react: React,
   tagName: 'obc-sequence-card',
   elementClass: ObcSequenceCardElement,
   events: {
     
   }
  });
 
 